
import React from 'react';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface AdminPaginationControlsProps {
  currentPage: number;
  totalPages: number;
  pageSize: number;
  totalItems: number;
  startIndex: number;
  endIndex: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
  onNextPage: () => void;
  onPreviousPage: () => void;
}

const AdminPaginationControls: React.FC<AdminPaginationControlsProps> = ({
  currentPage,
  totalPages,
  pageSize,
  totalItems,
  startIndex,
  endIndex,
  hasNextPage,
  hasPreviousPage,
  onPageChange,
  onPageSizeChange,
  onNextPage,
  onPreviousPage,
}) => {
  return (
    <div className="flex items-center justify-between text-sm">
      <div className="flex items-center gap-4">
        <p className="text-muted-foreground">
          Showing <span className="font-medium text-foreground">{totalItems > 0 ? startIndex + 1 : 0}</span> to{' '}
          <span className="font-medium text-foreground">{Math.min(endIndex, totalItems)}</span> of{' '}
          <span className="font-medium text-foreground">{totalItems}</span> results
        </p>
        
        <div className="flex items-center gap-2">
          <span className="text-muted-foreground">Show:</span>
          <Select value={pageSize.toString()} onValueChange={(value) => onPageSizeChange(Number(value))}>
            <SelectTrigger className="w-16 h-7 text-xs">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="10" className="text-xs">10</SelectItem>
              <SelectItem value="25" className="text-xs">25</SelectItem>
              <SelectItem value="50" className="text-xs">50</SelectItem>
              <SelectItem value="100" className="text-xs">100</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
      
      <div className="flex items-center gap-3">
        <p className="text-muted-foreground">
          Page <span className="font-medium text-foreground">{currentPage}</span> of{' '}
          <span className="font-medium text-foreground">{totalPages}</span>
        </p>
        <div className="flex items-center">
          <Button
            variant="ghost"
            size="sm"
            onClick={onPreviousPage}
            disabled={!hasPreviousPage}
            className="h-7 w-7 p-0 disabled:opacity-30 disabled:cursor-not-allowed"
          >
            <ChevronLeft className="h-3 w-3" />
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={onNextPage}
            disabled={!hasNextPage}
            className="h-7 w-7 p-0 disabled:opacity-30 disabled:cursor-not-allowed"
          >
            <ChevronRight className="h-3 w-3" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AdminPaginationControls;
